import { useEffect, useState } from 'react'

import { type OpenableControls } from '../../generic-hooks'
import { HTTP_STATUS_CODE_UNAUTHORIZED } from '../../http'
import { useApiOrdersSwrGetOrders } from '../../order'
import { useUserApiSwrSessionV1Customer } from '../../user-data'

export const useDirectContactFormOrderLoginModal = (
  loginModalControls: OpenableControls,
): boolean => {
  const { data: userData } = useUserApiSwrSessionV1Customer()
  const isLoggedIn = Boolean(userData?.customerNumber)
  const { error } = useApiOrdersSwrGetOrders()
  const [hasOpenedLoginModal, setHasOpenedLoginModal] = useState(false)

  useEffect(() => {
    if (
      (!isLoggedIn || error?.status === HTTP_STATUS_CODE_UNAUTHORIZED) &&
      !hasOpenedLoginModal
    ) {
      loginModalControls.handleOpen()
      setHasOpenedLoginModal(true)
    }
  }, [isLoggedIn, hasOpenedLoginModal, loginModalControls, error?.status])

  return isLoggedIn
}
